import { render, staticRenderFns } from "./inputtextarea.vue?vue&type=template&id=9ad8d512"
import script from "./inputtextarea.js?vue&type=script&lang=js&external"
export * from "./inputtextarea.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports